import React, { useEffect, useState } from "react";
import DashboardLayout from "./DashboardLayout";
import { FilterIcon, CheckIcon, XIcon, ChartNoAxesCombinedIcon } from "lucide-react";
import DPKAccountMetrics from "./DPKAccountMetrcis";
import OtherAccountsMetrics from "./OtherAccountsMetrics";
import MetricsPage from "./metrics-dashboard/metrics-page";
import apiClient from "../utils/apiClient";
import { dpk_trade_metrics } from "../constant";
import server from "../utils/serverConfig";

export default function Dashboard() {
  const [metricsData, setMetricsData] = useState({});
  const [assetMetricsData, setAssetMetricsData] = useState({});
  const [isLoading, setIsLoading] = useState(true);

  const [newMetricsData, setNewMetricsData] = useState(dpk_trade_metrics)

  const getMetricsData = () => {
    apiClient
      .get(`${server.godseye.baseUrl}dpk-trade-metrics`)
      .then((response) => {
        setMetricsData(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getAssetMetricsData = () => {
    apiClient
      .get(`${server.godseye.baseUrl}dpk-trade-metrics-by-asset`)
      .then((response) => {
        setAssetMetricsData(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    setIsLoading(true);
    getMetricsData();
    getAssetMetricsData();
    setIsLoading(false);
  }, []);

  console.log("Metrics Data printed -----> \n", metricsData);

  return (
    <DashboardLayout>
      <div className="z-0 relative w-full h-full  overflow-hidden  bg-black font-inter">

         {/* <MetricsPage dkpMetricsData={dpk_trade_metrics} /> */}
        {!isLoading && metricsData && Object.keys(metricsData).length > 0 ? (
          <MetricsPage dkpMetricsData={metricsData} assetMetricsData={assetMetricsData} />
        ) : (
          <div className="flex flex-col space-y-4 items-center justify-center text-lg font-medium text-white/80 h-full w-full ">
            <ChartNoAxesCombinedIcon className="h-20 w-20 text-white/50" />
          <p>  No Metrics data Found</p>
          </div>
        )}
      </div>
    </DashboardLayout>
  );
}












// import React, { useEffect, useState } from "react";
// import DashboardLayout from "./DashboardLayout";
// import { FilterIcon, CheckIcon, XIcon, ChartNoAxesCombinedIcon } from "lucide-react";
// import DPKAccountMetrics from "./DPKAccountMetrcis";
// import OtherAccountsMetrics from "./OtherAccountsMetrics";
// import MetricsPage from "./metrics-dashboard/metrics-page";
// import apiClient from "../utils/apiClient";
// import { dpk_trade_metrics } from "../constant";

// export default function Dashboard() {
//   const [metricsData, setMetricsData] = useState({});
//   const [isLoading, setIsLoading] = useState(true);

//   const [newMetricsData, setNewMetricsData] = useState(dpk_trade_metrics)

//   const getMetricsData = () => {
//     let config = {
//       method: "get",
//       url: "https://godseye.server.sypto.xyz/dpk-trade-metrics",
//       headers: {
//         "Content-Type": "application/json",
//       },
//     };

//     apiClient
//       .request(config)
//       .then((response) => {
//         setMetricsData(response.data);
//       })
//       .catch((error) => {
//         console.log(error);
//       });
//   };

//   useEffect(() => {
//     setIsLoading(true);
//     getMetricsData();
//     setIsLoading(false);
//   }, []);

//   console.log("Metrics Data printed -----> \n", metricsData);

//   return (
//     <DashboardLayout>
//       <div className="z-0 relative w-full h-full  overflow-hidden  bg-black font-inter">

//          {/* <MetricsPage dkpMetricsData={dpk_trade_metrics} /> */}
//         {!isLoading && metricsData && Object.keys(metricsData).length > 0 ? (
//           <MetricsPage dkpMetricsData={metricsData} />
//         ) : (
//           <div className="flex flex-col space-y-4 items-center justify-center text-lg font-medium text-white/80 h-full w-full ">
//             <ChartNoAxesCombinedIcon className="h-20 w-20 text-white/50" />
//           <p>  No Metrics data Found</p>
//           </div>
//         )}
//       </div>
//     </DashboardLayout>
//   );
// }
